import { useEffect, useState, useMemo, useRef, Fragment } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import Loading from "components/Loading";
import SelectBox from "components/elements/selectBox";
import {
    loadDropShippingList
} from "actions/productActions";
const DropShippingList = ({
    loadDropShippingList,
    product
}) => {
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState({});
    const [products, setProducts] = useState([]);
    const { t } = useTranslation();

    const { isLoading } = product;

    useEffect(() => {
        setProducts([])
        loadDropShippingList({ page, filter }).then(async (product) => setProducts(product))
    }, [loadDropShippingList, page, filter]);


    return (
        <div className="card mb-5 mb-xl-10 container">
            <div className="d-flex justify-content-between  mt-5">
                <SelectBox
                    options={[
                        { value: "", label: "All Category" },
                        { value: 1, label: "Clothing & Shoes" },
                        { value: 2, label: "Beauty & Accessories" },
                        { value: 3, label: "Books & Media" },
                        { value: 4, label: "Computer & Electronics" },
                        { value: 5, label: "Home & Living" },
                        { value: 6, label: "Tools & Toys" },
                        { value: 7, label: "Health & Foods" },
                        { value: 8, label: "Industry & Techs" }
                    ]}
                    name="category_id"
                    value={filter?.category_id}
                    onChange={(data) => {
                        setFilter((prev) => ({
                            ...prev,
                            category_id: data.value,
                        }));
                    }}
                    className="basic-multi-select al-custom-select-search-variants mr-1 mb-0 al-filter-table me-2 css-b62m3t-container"
                    placeholder={t("Select a category ... ")}
                />
                <SelectBox
                    options={[
                        { value: "", label: "All Warehouse" },
                        { value: 6, label: "US-ATL2" },
                        { value: 7, label: "US-LAX2" },
                        { value: 1, label: "US-LAX" },
                        { value: 4, label: "US-CNO" },
                        { value: 2, label: "CN-FJ" },
                        { value: 5, label: "US-ATL" },
                        { value: 8, label: "MY-KL" },
                    ]}
                    name="store_ids"
                    value={filter?.store_ids}
                    onChange={(data) => {
                        setFilter((prev) => ({
                            ...prev,
                            store_ids: data.value,
                        }));
                    }}
                    className="basic-multi-select al-custom-select-search-variants mr-1 mb-0 al-filter-table me-2 css-b62m3t-container"
                    placeholder={t("Select a warehouse ... ")}
                />
                <SelectBox
                    options={[
                        { value: "", label: "All Supply" },
                        { value: "FACTORY DIRECT", label: "FACTORY DIRECT" },
                        { value: "STABLE SUPPLIES", label: "STABLE SUPPLIES" },
                        { value: "BRAND VENDOR", label: "BRAND VENDOR" },
                    ]}
                    name="supply_mark"
                    value={filter?.supply_mark}
                    onChange={(data) => {
                        setFilter((prev) => ({
                            ...prev,
                            supply_mark: data.value,
                        }));
                    }}
                    className="basic-multi-select al-custom-select-search-variants mr-1 mb-0 al-filter-table me-2 css-b62m3t-container"
                    placeholder={t("Select a supply ... ")}
                />
                <div className="al-form-input-date">
                    <input type="text" className="form-control w-30" placeholder="Product title, SKU etc." name="name" value={filter?.name} onChange={(data) => {
                        setFilter((prev) => ({
                            ...prev,
                            name: data.value,
                        }));
                    }} />
                </div>
                <div className="al-form-input-date">
                    <button className="btn btn-primary" onClick={() => { }}>Search</button>
                </div>

            </div>
            <div className="row mt-3">
                {products.map((product, index) => (
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={index}>
                        <div className="card h-100 shadow-sm border rounded">
                            <div className="w-100" style={{ height: '180px', overflow: 'hidden' }}>
                                <img
                                    src={product?.image}
                                    alt={product?.title}
                                    className="w-100 h-100"
                                    style={{ objectFit: 'contain' }}
                                />
                            </div>

                            <div className="card-body d-flex flex-column justify-content-between">
                                <div>
                                    <h5 className="text-danger fw-bold mb-1 d-flex justify-content-between"><span>{product?.price} <i className="ki-duotone ki-information fs-4" data-tooltip-id="my-tooltip"
                                        data-tooltip-content={product?.description}>
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                        <span class="path3"></span>
                                    </i></span></h5>
                                    <h6 className="text-muted small">Supply: {product?.supply}</h6>
                                    <h6 className="text-truncate">{product?.title}</h6>
                                    <p className="text-muted mb-1 small">SKU: {product?.sku}</p>
                                    <p className="text-info mb-1 small">Category: {product?.category}</p>
                                    <p className="text-primary mb-0 small">Inventory: {product?.warehouse} <span className="text-danger" data-tooltip-id="my-tooltip"
                                        data-tooltip-content={t("Total Stock")}>({product?.inventory})</span></p>
                                    <p className="text-dark mb-0 small d-flex justify-content-between"><span>W: {product?.width} {product?.dimension_unit}</span><span>H: {product?.height} {product?.dimension_unit}</span><span>L: {product?.length} {product?.dimension_unit}</span></p>
                                    <p className="text-dark mb-0 small d-flex justify-content-between"><span>Weight: {product?.weight} {product?.weight_unit}</span></p>
                                </div>

                                <button className="btn btn-primary w-100 mt-3">
                                    Save Base. {product?.price}
                                </button>
                            </div>
                        </div>
                    </div>

                ))}
            </div>
            <div className="al-form-input-date mb-5">
                <button className="btn btn-secondary" onClick={() => { setPage(page - 1) }}>Back Page</button>
                <button className="btn btn-dark" onClick={() => { setPage(page + 1) }}>Next Page</button>
            </div>
            <Loading isLoading={isLoading} />
        </div>
    );
};

const mapStateToProps = ({ product }) => ({ product });
const mapDispatchToProps = {
    loadDropShippingList
};

export default connect(mapStateToProps, mapDispatchToProps)(DropShippingList);
